import apiClient from "./client";
import type { IdParam } from "../types/common";
import type {
  TemplateMailGetResponse,
  TemplateMailMutationResponse,
  TemplateMailPayload,
} from "../types/mail";

export const getTemplateMail = async (
  templateId: IdParam
): Promise<TemplateMailGetResponse> => {
  const { data } = await apiClient.get<TemplateMailGetResponse>(
    `/template_mail/${templateId}`
  );
  return data;
};

export const createTemplateMail = async (
  data: TemplateMailPayload
): Promise<TemplateMailMutationResponse> => {
  const { data: response } = await apiClient.post<TemplateMailMutationResponse>(
    "/template_mail",
    data
  );
  return response;
};

export const updateTemplateMail = async (
  templateId: IdParam,
  data: TemplateMailPayload
): Promise<TemplateMailMutationResponse> => {
  const { data: response } = await apiClient.put<TemplateMailMutationResponse>(
    `/template_mail/${templateId}`,
    data
  );
  return response;
};

export const deleteTemplateMail = async (
  templateId: IdParam
): Promise<TemplateMailMutationResponse> => {
  const { data } = await apiClient.delete<TemplateMailMutationResponse>(
    `/template_mail/${templateId}`
  );
  return data;
};
